import { BulkUploadType } from '../../../../enums/bulk-upload-type';
import { BulkUploadDto, UserBulkUploadRow } from '../../../../models/bulk-uploads/bulk-upload-dto';

export interface IBulkUploadProps {
  bulkUploadType: BulkUploadType;
  onValidate: () => void;
  setData: React.Dispatch<React.SetStateAction<BulkUploadDto<UserBulkUploadRow> | undefined>>;
}

export interface IBulkUploadPreviewWidgetProps {
  data: BulkUploadDto<UserBulkUploadRow>;
  setData: React.Dispatch<React.SetStateAction<BulkUploadDto<UserBulkUploadRow> | undefined>>;

  editedRows: Set<string>;
  setEditedRows: React.Dispatch<React.SetStateAction<Set<string>>>;

  setSelectedRow: React.Dispatch<React.SetStateAction<UserBulkUploadRow | undefined>>;

  reset: () => void;
  next: () => void;
}

export interface IBulkUploadEditFocusPanelProps {
  selectedRow: UserBulkUploadRow | undefined;
  onSubmit: (row: UserBulkUploadRow) => void;
}

export enum BulkUploadFieldNameEnum {
  FirstName = 'FirstName',
  LastName = 'LastName',
  Email = 'Email',
  JobTitle = 'JobTitle',
  Department = 'Department',
  Team = 'Team',
  Country = 'Country',
  Languages = 'Languages',
}